const getLocaleCode = require('../locales').getLocaleCode

module.exports = function getMessages(locale /*: string */) {
  return import(/* webpackChunkName: "i18n/[request]" */ './' + getLocaleCode(locale) + '.json')
}
